var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { produce } from 'immer';
import { numbersApi } from 'apis/numbers';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';
import { getNextFunctionalityState, smsFunctionalityStateText, } from '../utils/smsFunctionality';
import styles from './changeSmsFunctionalityModal.module.scss';
/** A component that displays a modal for changing the sms activation status. */
export const ChangeSmsFunctionalityModal = createAppModal({ type: 'settings:changeSmsFunctionality' }, ({ isOpen, modal, meta, hide }) => {
    const notify = useNotifications();
    const [updateNumber, { isLoading }] = numbersApi.useUpdateNumberMutation();
    const { smsTableDataItem, smsTableDataItem: { phoneNumber: { sms_functionality_state, e164_format }, }, } = modal.arg;
    // field is optional to disconnect ai changes from backend changes
    if (!sms_functionality_state)
        return null;
    /** Handles sending a request for sms functionality change. */
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        const nextState = getNextFunctionalityState(sms_functionality_state);
        try {
            const response = yield updateNumber({
                phoneNumber: e164_format,
                data: { sms_functionality_state: nextState },
            }).unwrap();
            meta === null || meta === void 0 ? void 0 : meta.resolve({
                updatedSmsTableDataItem: produce(smsTableDataItem, (draft) => {
                    draft.phoneNumber.sms_functionality_state =
                        response.data.sms_functionality_state;
                }),
            });
            notify({
                title: 'Request for change successfully sent',
                time: 3000,
            }, NotificationType.Success);
            hide === null || hide === void 0 ? void 0 : hide();
        }
        catch (_a) {
            notify({
                title: 'An error occured while sending the request',
            }, NotificationType.Error);
        }
    });
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: hide, className: styles.modal }, { children: [_jsx(ModalHead, { title: _jsxs(FlexBox, Object.assign({ alignItems: "baseline", gap: "200" }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-2" }, { children: smsFunctionalityStateText[sms_functionality_state] })), _jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: e164_format }))] })), onClose: hide }), _jsx(ModalBody, { children: _jsxs(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: ["We need to work some magic to change the status of this number. When you send this request, we'll notify our support team immediately.", _jsx("br", {}), _jsx("br", {}), "This process can take up to 2 business days."] })) }), _jsx(ModalFoot, { cancelOnClick: hide, confirmName: "Send request", confirmOnClick: handleConfirm, confirmProps: {
                    isLoading,
                } })] })));
});
